import type { INativeBridge } from '@erp/native/interfaces';
import { detectWebPlatform } from './platform';
import { createWebSecureStorage } from './secure-storage';
import { createWebPreferences } from './preferences';
import { createWebFileSystem } from './file-system';
import { createWebPrinter, createWebPosPrinter } from './printer';
import { createWebNotifications } from './notifications';
import { createWebDialog } from './dialog';
import { createWebUpdater } from './updater';
import { createWebDeepLink } from './deep-link';
import { createWebMenu } from './menu';
import { createWebNetwork } from './network';
import { createWebWindowBranding } from './window-branding';
import { createWebApiProxy } from './api-proxy';

export function createWebBridge(): INativeBridge {
  return {
    platform: detectWebPlatform(),
    secureStorage: createWebSecureStorage(),
    preferences: createWebPreferences(),
    fileSystem: createWebFileSystem(),
    printer: createWebPrinter(),
    posPrinter: createWebPosPrinter(),
    notifications: createWebNotifications(),
    dialog: createWebDialog(),
    updater: createWebUpdater(),
    deepLink: createWebDeepLink(),
    menu: createWebMenu(),
    network: createWebNetwork(),
    apiProxy: createWebApiProxy(),
    windowBranding: createWebWindowBranding(),
  };
}
